<template>
  <div>
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">

      <div class="exchange_box">

        <div class="exchange_top">
          <div class="exchange_screen">

            <div class="screen_left" v-bind:class="orderBy=='-sequenceNum'?'screen_slColor':''" @click="changeOrder('-sequenceNum')">推荐</div>
            <div class="screen_middle">|</div>
            <div class="screen_right" @click="changeOrder('+exchangePrice')">K币排序
              <img src="@/images/icon_jiage@3x.png" class="screen_right_icon_other" v-if="orderBy=='-sequenceNum'">
              <img src="@/images/icon_jiage_up@3x.png" class="screen_right_icon_other" v-if="orderBy=='+exchangePrice'">
              <img src="@/images/icon_jiage_down@3x.png" class="screen_right_icon_other" v-if="orderBy=='-exchangePrice'">
            </div>
          </div>
        </div>

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="exchange_bottom">
            <div class="exchange_bottom_ter">
              <div class="exchange_bottom_li" v-for="(productItem,index) in productList" :key="index" @click="goCardDetail(productItem.productId)">
                  <div class="bottom_li_img">
                    <van-image id="banner1" class="hellokitty_img" fit="cover" :src="productItem.detailImageUrl"/>
                  </div>
                  <div class="bottom_li_text">
                    <div class="bottom_li_name">{{productItem.productName}}</div>
                    <div class="bottom_li_money">
                      <span :class="productItem.priceTag!=null?'':'white_class'">¥{{productItem.priceTag}}</span>
                      <span>{{productItem.exchangePrice}}</span><span>K币</span>
                    </div>
                  </div>
              </div>
              <refresh class="refresh_style" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: productList.length,show:show}'></refresh>
            </div>
            <div class="cart_content" v-if="emptyList">
              <p class="tc grey zt14" style="padding: 2rem 0">暂无可售商品信息</p>
            </div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </div>

</template>

<script type="javascript">
  import { getExchangeZoneList} from '@/router/api';
  import { storeName,prodCatalogId } from '@/router/Constant';
  import { setStore,getStore,getCookie,setCookie,} from '@/utils/mUtil';
  import { NavBar,Swipe,SwipeItem,Image,Grid,Tabbar,Toast,Search,PullRefresh,Dialog } from 'vant';
  import footerView from "../common/footer";
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: "distributionExchange",

    components: {
      [NavBar.name]: NavBar,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [Search.name]: Search,
      [PullRefresh.name]: PullRefresh,
      [Dialog.name]: Dialog,
      footerView,
      refresh,
      loading,
    },

    data:function(){
      return {
        productList:[],
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        externalLoginKey:getStore('externalLoginKey'),
        viewIndex:0,
        viewSize:20,
        totalPage:0,
        totalSize:0,
        isLoading: false,
        allLoaded: false,
        emptyList:false,
        show: false,
        showLoading:true,
        orderBy:'-sequenceNum' //K币："+priceTag","-priceTag"，推荐："-sequenceNum"

      }
    },

    methods:{
      async initData() {
        this.getExchangeInfoAction();
      },

      //获取兑换列表
      getExchangeInfoAction (){
        var param = {
          externalLoginKey:this.externalLoginKey,
          productStoreId:this.productStoreId,
          prodCatalogId:this.prodCatalogId,
          viewSize:this.viewSize,
          viewIndex:this.viewIndex,
          orderBy:this.orderBy
        }
        console.log(param)
        getExchangeZoneList(param)
          .then(res => {
            console.log("getExchangeZoneList")
            console.log(res);
            // debugger
            if (res.data.productList.length == 0) {
              this.emptyList = true;
            } else {
              this.emptyList = false;
            }
            if (res.data.productList.length < this.viewSize) {
              this.allLoaded = true
              this.show = false
            } else {
              this.allLoaded = false
              this.show = true
            }
            this.productList = res.data.productList
            this.viewIndex = res.viewIndex;


            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);
          })
          .catch(err => {
            // debugger
            console.log(err);
          });
      },

      //下拉刷新
      onRefresh() {
        console.log(1);
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          var param = {
            externalLoginKey:this.externalLoginKey,
            productStoreId:this.productStoreId,
            prodCatalogId:this.prodCatalogId,
            viewSize:this.viewSize,
            viewIndex:this.viewIndex,
            orderBy:this.orderBy
          }
          getExchangeZoneList(param)
            .then(res => {
              console.log("getExchangeZoneList")
              console.log("上拉加载")
              console.log(res)
              this.show = true
              if (res.data.productList.length < this.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }
              var oldProductList = this.data.productList
              var newProductList = oldProductList.concat(res.data.productList)
              this.productList = newProductList
              this.viewIndex = res.viewIndex;
              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
            })
            .catch(err => {
              console.log(err);
            });
        }
      },

      //改变筛选条件
      changeOrder:function(orderBy){
        if(orderBy == '-sequenceNum'){
          this.orderBy = '-sequenceNum'
        }else if(orderBy == '+exchangePrice'){
          if(this.orderBy == '+exchangePrice'){
            this.orderBy = '-exchangePrice'
          }else{
            this.orderBy = '+exchangePrice'
          }
          //this.orderBy = '-sequenceNum'
        }
        this.productList = []
        this.viewIndex = 0
        this.getExchangeInfoAction()
      },


      //跳转至商品详情
      goCardDetail:function (productId) {
        this.$router.push({path:'/exchangeDetail',query:{goodsId:productId}})
      }

    },

    mounted() {
      this.initData();
    }
  }
</script>

<style scoped>
  .exchange_box{
    width: 100%;
    height: 100vh;
    background: #f4f4f4;}
  .exchange_top{
    width: 100%;
    box-shadow:0px 0px 0.3rem #cdcdcd;
    height: 2.56rem;
  }
  .exchange_screen{
    width: 100%;
    height: 2.56rem;
    line-height: 2.56rem;
    background-color:white;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .screen_left{ width: 11rem;
    height: 100%;
    font-size: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold
  }

  .screen_slColor{
    color: #ED79A1
  }
  .screen_middle{
    width: 0.14rem;
    height: 100%; display: flex; justify-content: center; align-items: center; color: #ED79A1}
  .screen_right{ width: 11rem; height: 100%; font-size: 0.75rem; display: flex; justify-content: center; align-items: center; font-weight: bold}
  .screen_right_icon{ width: 0.75rem; padding-left: 0.2rem}
  .screen_right_icon_other{width: 1.5rem;height: 1.5rem;margin: 0 0 0 0.2rem;}
  .exchange_bottom{ width: 100%; height: auto;position: relative; background: #f4f4f4;}
  .exchange_bottom_ter{  width: 100%; height: auto; display: flex; flex-wrap: wrap; padding-bottom: 0.75rem}
  .exchange_bottom_li{ width: 10.6rem; height: 12.5rem; border-radius: 0.5rem; background: #FFFFFF; box-shadow:0px 0px 0.3rem #cdcdcd; overflow: hidden; margin-top: 0.75rem; overflow: hidden; margin-left: 0.75rem}
  .exchange_bottom_for{ width: 10.6rem; height: 12.5rem;}
  .bottom_li_img{ width: 100%; height: 9.37rem; overflow: hidden; display: flex; justify-content: center; align-items: center}
  .bottom_li_text{ width: 100%; height: 3.15rem; position: relative; margin: 0 auto}
  .bottom_li_name{ width: 90%; height: 1.03rem; font-size: 0.75rem; font-weight: bold; position: relative; margin: 0 auto; line-height: 1.03rem; top: 0.4rem; text-align: left; letter-spacing: 0.05rem; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}
  .bottom_li_money{ width: 90%; height: 1.15rem; font-size: 0.3rem; font-weight: bold; position: relative; margin: 0 auto; line-height: 1.15rem;  top: 0.6rem; text-align: right;}
  .bottom_li_money span:nth-child(2){ font-size: 1rem; padding-left: 0.3rem; color: #FF0000; font-weight: bold}
  .bottom_li_money span:nth-child(1){color: #D2CFD2;text-decoration: line-through;font-size: 0.75rem; }
  .bottom_li_money span:nth-child(3){ font-size: 0.75rem; color: #FF0000;}
  .hellokitty_img{ max-width: 10.6rem}
  .refresh_style{ width: 100%;}
  .white_class{color: white!important;}

</style>




// WEBPACK FOOTER //
// src/components/page/mine/distributionExchange.vue